import axios from 'axios'

// 创建axios实例
const api = axios.create({
  baseURL: '/open', // 使用代理路径，匹配实际接口路径
  timeout: 10000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
});

// 将对象转换为form表单格式
const objectToFormData = (obj) => {
  const formData = new URLSearchParams()
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key] !== null && obj[key] !== undefined) {
      formData.append(key, obj[key])
    }
  }
  return formData
}

// 请求拦截器
api.interceptors.request.use(
  config => {
    // 将请求数据转换为form格式
    if (config.data && typeof config.data === 'object') {
      config.data = objectToFormData(config.data)
    }
    
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
api.interceptors.response.use(
  response => {
    // 统一处理响应数据
    return response.data
  },
  error => {
    // 统一处理错误
    console.error('API请求错误:', error)
    
    if (error.response) {
      // 服务器返回错误状态码
      const { status, data } = error.response
      switch (status) {
        case 403:
          console.error('没有权限访问')
          break
        case 404:
          console.error('请求的资源不存在')
          break
        case 500:
          console.error('服务器内部错误')
          break
        default:
          console.error(`请求失败: ${status}`)
      }
      return Promise.reject(data || error.message)
    } else if (error.request) {
      // 网络错误
      console.error('网络连接错误')
      return Promise.reject('网络连接错误，请检查网络设置')
    } else {
      // 其他错误
      return Promise.reject(error.message)
    }
  }
)

// 新闻相关API
export const newsAPI = {
  // 获取新闻列表
  getNewsList(params = {}) {
    return api.post('/NewsAPI.m', params)
  },
  
  // 根据ID获取新闻详情
  getNewsDetail(id) {
    return api.post('/NewsAPI!detail.m', { id })
  },
  
  // 获取新闻分类列表
  getNewsCategories() {
    return api.post('/NewsAPI!categories.m', {})
  },
  
  // 根据分类获取新闻
  getNewsByCategory(categoryId, params = {}) {
    return api.post('/NewsAPI!category.m', { categoryId, ...params })
  },
  
  // 增加新闻浏览量
  increaseViewCount(id) {
    return api.post('/NewsAPI!addViewCount.m', { id })
  }
}

export default api